var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 164,
    viewBox: "0 0 182 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.373 69.0411L72.6945 150.989C67.3813 155.401 58.4837 156.469 52.8384 153.372L12.434 131.207C6.78867 128.11 6.51901 122.012 11.8322 117.6L110.511 35.6521C115.824 31.2397 124.721 30.1718 130.367 33.2688L170.771 55.4346C176.416 58.5316 176.686 64.6287 171.373 69.0411Z",
    fill: "#00A0A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2467 85.4836L74.651 107.649M42.1685 77.9372L82.5728 100.103M113.612 72.9334L113.115 58.9009M127.559 31.4418C136.169 36.1648 136.58 45.4628 128.477 52.1917C120.374 58.9206 106.806 60.5493 98.1966 55.8263C89.5874 51.1034 89.1762 41.8053 97.2789 35.0764C105.382 28.3475 118.95 26.7189 127.559 31.4418ZM171.168 41.4251L72.4895 123.373C67.1762 127.785 58.2787 128.853 52.6334 125.756L12.229 103.591C6.58369 100.494 6.31402 94.3965 11.6272 89.9841L110.305 8.03618C115.619 3.62378 124.516 2.55581 130.162 5.65284L170.566 27.8186C176.211 30.9156 176.481 37.0127 171.168 41.4251Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_131",
    x: 0.896973,
    y: 1.87814,
    width: 181.001,
    height: 161.266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_131",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUx);
export default __webpack_public_path__ + "static/media/ux.7e5659ab0360ee3efeafe398be74c440.svg";
export { ForwardRef as ReactComponent };